import React from 'react';
import ContactUs from '../../../About/ContactUs/ContactUs';
import ShowDetails from '../ShowDetails/ShowDetails';

const ServiceDetails = () => {
    return (
        <div>
            <ShowDetails />
            <ContactUs />
        </div>
    );
};

export default ServiceDetails;